exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span.required{color:red;font-weight:700}h3{font-weight:700;font-size:18px}.workshop-description{font-size:12px;color:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/assets/css/global.css
// module id = 134
// module chunks = 21